var Component = require("!../../../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-e205e772\",\"hasScoped\":false,\"preserveWhitespace\":false}!../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MentoringOldManIcon.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/oldman/MentoringOldManIcon.vue
// module id = 8d2dbfc281bd5f888830
// module chunks = 89